import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const WellnessInsightsComponentDefinitionSchema = withDefaults({
  type: 'wellness-insights-component-definition',
  objectExtensions: ['wellness-insights-component-definition'],
  fields: [
    {
      kind: 'attribute',
      name: 'type',
    },
    {
      kind: 'attribute',
      name: 'name',
    },
    {
      kind: 'attribute',
      name: 'subtitle',
    },
    {
      kind: 'attribute',
      name: 'text',
    },
    {
      kind: 'attribute',
      name: 'order',
    },
    {
      kind: 'belongsTo',
      name: 'wellnessTrain',
      type: 'wellness-train',
      options: {
        async: false,
        inverse: 'componentDefinitions',
      },
    },
  ],
});

export default WellnessInsightsComponentDefinitionSchema;
